'use strict';

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

var _jszip = require('jszip');

var _jszip2 = _interopRequireDefault(_jszip);

var _sprintfJs = require('sprintf-js');

var _fileSaver = require('file-saver');

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _draw = require('./draw');

var _draw2 = _interopRequireDefault(_draw);

var _keys = require('./lib/keys');

var _keys2 = _interopRequireDefault(_keys);

var _mouse = require('./lib/mouse');

var _mouse2 = _interopRequireDefault(_mouse);

var _output = require('./lib/output');

var _output2 = _interopRequireDefault(_output);

var _spectrum = require('./lib/spectrum');

var _spectrum2 = _interopRequireDefault(_spectrum);

var _util = require('./lib/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selfDrag = false;
var buffer = void 0;
var players = [];
var gallery = void 0;
var sr = 44100;
var last_i = 0;
var _r = 8,
    _i = 8;
function init() {
  (0, _util.requestAudioContext)(ready);
  document.body.addEventListener('dragover', dragover);
  document.body.addEventListener('dragstart', dragstart);
  document.body.addEventListener('drop', drop);
  document.querySelector("#upload").addEventListener('change', handleFileSelect);
  // draw.onFrame(() => {})
  _draw2.default.resize(256, 256);

  gallery = document.querySelector('#gallery');
  _mouse2.default.register({
    move: function move(x, y) {}
  });
  _keys2.default.listen(function (z) {
    // console.log(z)
    play((0, _util.mod)(z, players.length));
  });
}
function ready() {}
function dragover(e) {
  e.preventDefault();
}
function dragstart(e) {
  selfDrag = true;
}
function drop(e) {
  e.stopPropagation();
  e.preventDefault();

  if (e.dataTransfer && !selfDrag) {
    if (e.dataTransfer.files.length) {
      handleFileSelect(e);
    }
  } else {
    handleFileSelect(e);
  }
  selfDrag = false;
}
var files = void 0,
    file_index = 0;
function handleFileSelect(e) {
  files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
  loadNext();
}
function loadNext() {
  var file = files[file_index++];
  if (!file) return;
  load(file);
}
function load(file) {
  players = [];
  buffer = new _tone2.default.Buffer(URL.createObjectURL(file), loadBuffer, function (err) {
    return console.error('err', err);
  });
}
function loadBuffer() {
  console.log('loaded buffer', buffer);
  var pcm = buffer._buffer.getChannelData(0);
  sr = buffer._buffer.sampleRate;
  if (!pcm) return;

  var FRAME_LENGTH = 126 * 255;
  var FRAME_OFFSET = FRAME_LENGTH / 4;

  var zip = new _jszip2.default();

  var zip_folder = zip.folder("images");

  for (var offset = 0, count = 0, _len = pcm.length - FRAME_LENGTH; offset < _len; offset += FRAME_OFFSET, count += 1) {
    if (count % 100 === 0) console.log(count);
    // console.log('generating', count, offset)
    // let player = render(pcm.slice(offset, offset+FRAME_LENGTH), count, zip_folder)
    render(pcm.slice(offset, offset + FRAME_LENGTH), count, zip_folder);
    // register(player, count)
    // if (count > 20) break
  }

  console.log('done exporting');
  zip.generateAsync({ type: "blob" }).then(function (content) {
    console.log('saving zip');
    _fileSaver2.default.saveAs(content, "img2pix.zip");
    setTimeout(loadNext, 1000);
  });
  // play(0)
}
function render(pcm, count, zip) {
  var fft = _spectrum2.default.toSpectrum(pcm, sr);
  // console.log('render', fft)
  // const pcm_rev = pcm.slice().reverse()
  // const spec_rev = spectrum.toSpectrum(pcm_rev, spec.sr)
  _draw2.default.clear();

  var _draw$raw_spectrum = _draw2.default.raw_spectrum(fft, 0, 256, 0, 256, _r, _i),
      canvas = _draw$raw_spectrum.canvas,
      imageData = _draw$raw_spectrum.imageData;

  var dataURL = canvas.toDataURL("image/png");
  if (zip) {
    var fn = (0, _sprintfJs.sprintf)('frame_%05d.png', count);
    zip.file(fn, dataURL.split(',')[1], { base64: true });
  }
  return { fft: fft, canvas: canvas, imageData: imageData, dataURL: dataURL };
}
function play(i) {
  // console.log('play', i)
  last_i = i;
  var player = players[(0, _util.clamp)(i, 0, players.length)];
  // const { canvas, imageData } = draw.raw_spectrum(fft, 0, 256, 0, 256, 1, 1)
  // console.log(_r, _i)
  // const { canvas, imageData } = draw.raw_spectrum(player.fft, 0, 256, 0, 256, _r, _i)
  var new_fft = _spectrum2.default.fromImageData(player.imageData, 44100, _r, _i);
  // gallery.innerHTML = ''

  // console.log(player.fft.data, new_fft.data)
  var buf = _spectrum2.default.fromSpectrum(new_fft);
  var _p = new _tone2.default.Player(buf);
  _p.connect(_output2.default);
  _p.start(_tone2.default.now());
  redraw(new_fft);
}
function redraw(new_fft) {
  var _draw$raw_spectrum2 = _draw2.default.raw_spectrum(new_fft, 0, 256, 0, 256, _r, _i),
      canvas = _draw$raw_spectrum2.canvas,
      imageData = _draw$raw_spectrum2.imageData;
}
function register(player, i) {
  // console.log('register', player)
  players.push(player);
  player.canvas.addEventListener('click', function () {
    play(i);
  });
  // gallery.appendChild(player.canvas)
}
init();


//////////////////
// WEBPACK FOOTER
// ./client/index.js
// module id = 62
// module chunks = 0